//header-offr-strip

var acc = document.querySelectorAll(".product-accordion");

acc.forEach(function (accordion) {
  accordion.addEventListener("click", function () {
    this.classList.toggle("active");
    var panel = this.nextElementSibling;
    if (this.classList.contains("active")) {
      panel.style.maxHeight = "fit-content";
    } else {
      panel.style.maxHeight = "0px";
    }
  });
});

var acc = document.querySelectorAll(".product-accordion-inner-accordion");

acc.forEach(function (accordion) {
  accordion.addEventListener("click", function () {
    this.classList.toggle("active");
    var panel = this.nextElementSibling;
    if (panel.style.maxHeight) {
      panel.style.maxHeight = null;
    } else {
      panel.style.maxHeight = panel.scrollHeight + "px";
    }
  });
});

//swiper
var swiper = new Swiper(".homeBannerSwiper", {
  speed: 500,
  spaceBetween: 0,
  slidesPerView: 1,
  loop:true,
  autoplay: {
    delay: 1800,
    disableOnInteraction: false,
  },
  navigation: {
    nextEl: ".home-banner-next ",
    prevEl: ".home-banner-prev",
  },
});

var swiper = new Swiper(".homeBrandSwiper", {
  speed: 500,
  spaceBetween: 16,
  slidesPerView: 3.6,
  // autoplay: {
  //   delay: 2000,
  //   disableOnInteraction: false,
  // },
  breakpoints: {
    768: {
      slidesPerView: 6,
      spaceBetween: 16,
    },
    1024: {
      slidesPerView: 7.8,
      spaceBetween: 26,
    },
  },
});

var swiper = new Swiper(".homeServiceSwiper", {
  speed: 500,
  slidesPerView: 1,
  loop: true,
  autoplay: {
    delay: 2000,
    disableOnInteraction: false,
  },
});

var swiper = new Swiper(".homeCategorySwiper", {
  speed: 500,
  spaceBetween: 25,
  slidesPerView: 4,
  // autoplay: {
  //   delay: 2000,
  //   disableOnInteraction: false,
  // },
  breakpoints: {
    768: {
      slidesPerView: 5,
      spaceBetween: 30,
    },
    1024: {
      slidesPerView: 8,
      spaceBetween: 60,
    },
  },
});

var swiper = new Swiper(".homePriceSwiper", {
  speed: 500,
  spaceBetween: 10,
  slidesPerView: 3.3,
  navigation: {
    nextEl: ".home-price-next",
    prevEl: ".home-price-prev",
  },
  breakpoints: {
    768: {
      slidesPerView: 6,
      spaceBetween: 10,
    },
    1400: {
      slidesPerView: 8,
      spaceBetween: 20,
    },
  },
});

var swiper = new Swiper(".home-gadgets-swiper", {
  speed: 500,
  spaceBetween: 30,
  slidesPerView: 2,
  navigation: {
    nextEl: ".home-gadgets-next",
    prevEl: ".home-gadgets-prev",
  },
  breakpoints: {
    768: {
      slidesPerView: 2,
      spaceBetween: 30,
    },
    1024: {
      slidesPerView: 4,
      spaceBetween: 26,
    },
  },
});

var swiper = new Swiper(".home-testimonial-swiper", {
  speed: 500,
  spaceBetween: 10,
  slidesPerView: 1.1,
  navigation: {
    nextEl: ".home-testimonial-next",
    prevEl: ".home-testimonial-prev",
  },
  pagination: {
    el: ".home-testimonial-pagination",
  },
  breakpoints: {
    768: {
      slidesPerView: 2.1,
      spaceBetween: 10,
    },
    992: {
      slidesPerView: 1.7,
      spaceBetween: 21,
    },
  },
});

var swiper = new Swiper(".home-products-swiper", {
  speed: 500,
  spaceBetween: 30,
  slidesPerView: 1.3,
  navigation: {
    nextEl: ".home-products-next",
    prevEl: ".home-products-prev",
  },
  breakpoints: {
    768: {
      slidesPerView: 2,
      spaceBetween: 30,
    },
    992: {
      slidesPerView: 4,
      spaceBetween: 22,
    },
    1200: {
      slidesPerView: 5,
      spaceBetween: 18,
    },
  },
});

var swiper = new Swiper(".home-buy-now-swiper", {
  speed: 500,
  spaceBetween: 10,
  slidesPerView: 1.15,
  navigation: {
    nextEl: ".home-buy-next",
    prevEl: ".home-buy-prev",
  },
  breakpoints: {
    768: {
      slidesPerView: 2.2,
      spaceBetween: 20,
    },
    1024: {
      slidesPerView: 2,
      spaceBetween: 22,
    },
  },
});

var swiper = new Swiper(".cartMiniSlider", {
  direction: "vertical",
  speed: 500,
  spaceBetween: 10,
  slidesPerView: 4,
  navigation: {
    nextEl: ".cartMiniSlider-next",
    prevEl: ".cartMiniSlider-prev",
  },
});

var swiper = new Swiper(".cartMainSlider", {
  speed: 500,
  effect: "fade",
  spaceBetween: 10,
  slidesPerView: 1,
  loop: true,

  navigation: {
    nextEl: ".cartMainSlider-next",
    prevEl: ".cartMainSlider-prev",
  },
});

document.addEventListener("DOMContentLoaded", () => {
  let mainHeader = document.querySelector(".main-header");
  let main = document.querySelector("main");
  let headerBtn = document.querySelector(".header-strip .strip-close");

  const InitialHeaderHeight = mainHeader.getBoundingClientRect().height;
  main.style.marginTop = InitialHeaderHeight - 4 + "px";

  // Check localStorage to see if the offer should be hidden
  const headerHiddenTime = localStorage.getItem("headerHiddenTime");
  const currentTime = Date.now();
  const oneDay = 24 * 60 * 60 * 1000; // Milliseconds in one day

  if (headerHiddenTime && currentTime - headerHiddenTime < oneDay) {
    mainHeader.classList.add("hide-offer");
    const NewheaderHeight = mainHeader.getBoundingClientRect().height;
    main.style.marginTop = NewheaderHeight + "px";
  }

  if (headerBtn) {
    headerBtn.addEventListener("click", () => {
      mainHeader.classList.add("hide-offer");
      const NewheaderHeight = mainHeader.getBoundingClientRect().height;
      main.style.marginTop = NewheaderHeight + "px";

      // Store the current time in localStorage
      localStorage.setItem("headerHiddenTime", currentTime);
    });
  }

  //home-intro-video
  let videoElm = document.querySelector(".home-intro-vdo video");
  let videoElmWrap = document.querySelector(".home-intro-vdo .video-wrap");
  if (videoElm) {
    videoElmWrap.addEventListener("mouseenter", () => {
      videoElm.play();
      videoElmWrap.classList.add("play");
    });
    videoElmWrap.addEventListener("mouseleave", () => {
      videoElmWrap.classList.remove("play");
      videoElm.pause();
      video.currentTime = 0;
    });
  }

  //toggle-dropdown

  const navItem = document.querySelectorAll(
    ".drop-down-menu .dr-main-ul .dr-main-li"
  );
  const deskHamb = document.querySelector(".header-nav-all");

  deskHamb?.addEventListener("mouseleave", () => {
    navItem.forEach((items) => {
      items.classList.remove("active");
    });
  });

  navItem.forEach((item) => {
    item.addEventListener("mouseenter", () => {
      //remove active class
      navItem.forEach((items) => {
        items.classList.remove("active");
      });

      // to add active class.
      item.classList.add("active");
    });
  });

  //custom drp

  const navItems = document.querySelectorAll(".drp-main-li");

  const content = document.querySelector(".mega-menu__content");

  // content?.addEventListener("mouseleave", () => {
  //   navItems.forEach((items) => {
  //     items.classList.remove("active");
  //   });
  // });

  navItems.forEach((item) => {
    item.addEventListener("mouseenter", () => {
      //remove active class
      navItems.forEach((items) => {
        items.classList.remove("active");
      });

      // to add active class.
      item.classList.add("active");
    });
  });

  //annoying loader

  let roundLoader = document.querySelector(".predictive-search__loading-state");

  roundLoader.style.setProperty("opacity", "1");

  // Selecting an element that has the predictive-search attribute and is open
  const openPredictiveSearch = document.querySelector(
    "div[predictive-search][open]"
  );

  if (openPredictiveSearch) {
    // Do something with the open predictive search element
    console.log("Predictive search is open:", openPredictiveSearch);
  }

  var animation = lottie.loadAnimation({
    container: document.querySelector(".lottie-container"), // The container element
    renderer: "svg", // or 'html'
    loop: true, // Whether to loop the animation
    autoplay: true, // Whether to start the animation automatically
    path: "https://cdn.shopify.com/s/files/1/0615/7287/4282/files/Lottie_new.json?v=1734025685",
  });
  var animation2 = lottie.loadAnimation({
    container: document.querySelector(".lottie-container-mob"), // Second container
    renderer: "svg",
    loop: true,
    autoplay: true,
    path: "https://cdn.shopify.com/s/files/1/0615/7287/4282/files/Lottie_new.json?v=1734025685",
  });

  // let SortElem = document.querySelector(".moblie-sort-sec");
  // let filterElem = document.querySelector(".moblie-filter-sec");

  // Function to handle the logic
  function handleKeyPressOrDown() {
    // Set a timeout to delay the action
    setTimeout(() => {
      var spanElement = document.querySelector(".hide-new-class.hidden");
      var innerContent = spanElement ? spanElement.innerHTML : "";
      var buttonElement = document.querySelector(".hide-close-bt");

      if (
        innerContent.trim() === "" ||
        innerContent.includes(
          "Check the spelling or use a different word or phrase"
        )
      ) {
        if (buttonElement) {
          buttonElement.style.display = "none";
        }
      } else {
        if (buttonElement) {
          buttonElement.style.display = "block";
        }
      }
    }, 1000); // Delay of 1000 milliseconds (1 second)
  }

  // Attach the function to both events
  document.addEventListener("keypress", handleKeyPressOrDown);
  document.addEventListener("keydown", handleKeyPressOrDown);

  document.addEventListener("click", (e) => {
    if (e.target.classList.contains("mobile-filter-sec")) {
      if (document.body.classList.contains("sort")) {
        document.body.classList.remove("sort");
      } else {
        document.body.classList.add("sort");
      }
    }
  });

  const cartWishlistSection = document.querySelector(".cart-wishlist-custom");
  const stickyColumn = document.querySelector(".product__column-sticky");

  // Find the closest section ancestor and add a class
  if (cartWishlistSection) {
    const closestSection = cartWishlistSection.closest("section");

    if (closestSection) {
      closestSection.classList.add("cart-wishlist-section"); // Add the new class

      // Append the closestSection to the product__column-sticky
      if (stickyColumn) {
        stickyColumn.appendChild(closestSection);
      }
    }
  }

  const scrollDiv = document.getElementById("scroll-to-div");

  if (scrollDiv) {
    scrollDiv.addEventListener("click", function () {
      document
        .getElementById("target-section")
        .scrollIntoView({ behavior: "smooth" });
    });
  }

  document
    .querySelectorAll(".footer-accordion .accordion-item")
    .forEach((item) => {
      item.addEventListener("click", () => {
        // Check if the clicked item already has the active class
        if (item.classList.contains("active")) {
          // Remove the active class if it already exists
          item.classList.remove("active");
        } else {
          // Remove active class from all items
          document
            .querySelectorAll(".accordion-item")
            .forEach((i) => i.classList.remove("active"));

          // Add active class to the clicked item
          item.classList.add("active");
        }
      });
    });

    document
    .querySelectorAll(".gadget-accordion .accordion-item")
    .forEach((item) => {

          let isActive = false;

      
      item.addEventListener("click", () => {
        
        // // Check if the clicked item already has the active class
        // if (item.classList.contains("active")) {
        //   // Remove the active class if it already exists
        //   item.classList.remove("active");
        // } else {
        //   // Remove active class from all items
          
        //   document
        //     .querySelectorAll(".accordion-item")
        //     .forEach((i) => i.classList.remove("active"));

        //   // Add active class to the clicked item
        //   item.classList.add("active");
        // }

        if(!isActive){
          document
            .querySelectorAll(".accordion-item")
            .forEach((i) => i.classList.remove("active"));

          // Add active class to the clicked item
          item.classList.add("active");
        } else{
          item.classList.remove("active");
        }

        if (item.classList.contains("active")) {
          isActive = true;
        }   else{
          isActive = false;
        }
        
      });
    });

      document
    .querySelectorAll(".faq-accordion .accordion-item")
    .forEach((item) => {

          let isActive = false;

      
      item.addEventListener("click", () => {
        
        // // Check if the clicked item already has the active class
        // if (item.classList.contains("active")) {
        //   // Remove the active class if it already exists
        //   item.classList.remove("active");
        // } else {
        //   // Remove active class from all items
          
        //   document
        //     .querySelectorAll(".accordion-item")
        //     .forEach((i) => i.classList.remove("active"));

        //   // Add active class to the clicked item
        //   item.classList.add("active");
        // }

        if(!isActive){
          document
            .querySelectorAll(".accordion-item")
            .forEach((i) => i.classList.remove("active"));

          // Add active class to the clicked item
          item.classList.add("active");
        } else{
          item.classList.remove("active");
        }

        if (item.classList.contains("active")) {
          isActive = true;
        }   else{
          isActive = false;
        }
        
      });
    });

  // Select the predictive search element
  const predictiveSearch = document.querySelector(".predictive-search");
  const resetButton = document.querySelector(
    ".search-modal__form .reset__button"
  );

  // Function to toggle the class on the body based on the 'open' attribute
  const toggleBodyClass = () => {
    if (predictiveSearch.getAttribute("results") === "true") {
      document.body.classList.add("predictive-search-open");
      resetButton.classList.remove("hidden");
    } else {
      document.body.classList.remove("predictive-search-open");
      resetButton.classList.add("hidden");
    }
  };

  // Initial check when the page loads
  toggleBodyClass();

  // Listen for attribute changes on the predictive search element
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.attributeName === "results") {
        toggleBodyClass();
      }
    });
  });

  // Observe changes to attributes on the predictive search element
  observer.observe(predictiveSearch, { attributes: true });

  // Example: Manually opening the predictive search for demonstration
  // predictiveSearch.setAttribute('open', 'true');

  // home reels

  let reelCardBtns = document.querySelectorAll(".home-listing .expert-card");
reelCardBtns.forEach((item) => {
    const btn = item.querySelector(".play-btn");
    const vdo = item.querySelector("video");

    let isVideoPlaying = false;

    btn.addEventListener("click", (e) => {
      if (!isVideoPlaying) {
        btn.classList.add("playing");
        vdo.play();

        // Pause other videos
        reelCardBtns.forEach((card) => {
          if (card !== item) {
            const otherVideo = card.querySelector("video");
            const otherBtn = card.querySelector(".play-btn");
            if (otherVideo && otherBtn) {
              otherVideo.pause();
              otherBtn.classList.remove("playing");
            }
          }
        });
      } else {
        btn.classList.remove("playing");
        vdo.pause();
      }

      vdo.addEventListener("play", () => {
        isVideoPlaying = true;
      });
      vdo.addEventListener("pause", () => {
        isVideoPlaying = false;
      });
    });
  });
  // reelCardBtns.forEach((item) => {
  //   let btn = item.querySelector(".play-btn");
  //   let vdo = item.querySelector("video");

  //   if (btn && vdo) {
  //     btn.addEventListener("click", () => {
  //       console.log("butotn clciked", vdo.paused);
  //       if (vdo.paused) {
  //        console.log("play 111", vdo.paused);

  //         // Play the video if it's paused
  //         btn.classList.add("playing");
  //         vdo.play();

  //         // Pause and reset other videos
  //         reelCardBtns.forEach((card) => {
  //           if (card !== item) {
  //             let otherVideo = card.querySelector("video");
  //             let plaYbtn = card.querySelector(".play-btn");
  //             if (otherVideo) {
  //               otherVideo.pause();
  //               // otherVideo.currentTime = 0;
  //             }
  //             plaYbtn.classList.remove("playing");
  //           }
  //         });
  //       } 
  //       else {
  //          console.log("play 222");
  //         // Pause the video if it's playing
  //         btn.classList.remove("playing");
  //         vdo.pause();
  //       }
  //     });
  //   }
  // });

  // reels detail pge

  const reelCardBtnsDetail = document.querySelectorAll(
    ".expert-detail-page .expert-card"
  );

  reelCardBtnsDetail.forEach((item) => {
    const btn = item.querySelector(".play-btn");
    const vdo = item.querySelector("video");

    let isVideoPlaying = false;

    btn.addEventListener("click", (e) => {
      if (!isVideoPlaying) {
        btn.classList.add("playing");
        vdo.play();

        // Pause other videos
        reelCardBtnsDetail.forEach((card) => {
          if (card !== item) {
            const otherVideo = card.querySelector("video");
            const otherBtn = card.querySelector(".play-btn");
            if (otherVideo && otherBtn) {
              otherVideo.pause();
              otherBtn.classList.remove("playing");
            }
          }
        });
      } else {
        btn.classList.remove("playing");
        vdo.pause();
      }

      vdo.addEventListener("play", () => {
        isVideoPlaying = true;
      });
      vdo.addEventListener("pause", () => {
        isVideoPlaying = false;
      });
    });
  });

  // Hamburger menu
  let hamburgerToggleBtn = document.querySelector(".mob-ham-button");
  let mobNavTop = document.querySelector(".header-strip").getBoundingClientRect().height;
  let mobNav=document.querySelector(".main-header .mobile-nav");

  if (mobNav && mobNavTop) {
  mobNav.style.top = `${mobNavTop}px`;
    
    setTimeout(() => {
      document.documentElement.style.setProperty("--mobNavTop", `${mobNavTop}px`);
    }, 1000);
  }


  
  if (hamburgerToggleBtn) {
    let buttonClicked = false;

    hamburgerToggleBtn.addEventListener("click", () => {
      if (buttonClicked) {
        document.body.classList.remove("mobile-menu-open");
      } else {
        document.body.classList.add("mobile-menu-open");
      }
      // Toggle the state of buttonClicked
      buttonClicked = !buttonClicked;
    });
  }
});

// //review
// let reviewTtl = document.getElementById(
//   "shopify-block-dadao_product_reviews_product_reviews_xJNTw9"
// );

// if (reviewTtl) {
//   reviewTtl.classList.add("active");

//   reviewTtl.addEventListener("click", () => {
//     reviewTtl.classList.toggle("active");
//   });
// }

// document.addEventListener("DOMContentLoaded", function () {
//   // Select all accordion buttons
//   const accordionButtons = document.querySelectorAll(".accordion-button");

//   accordionButtons.forEach((button) => {
//     button.addEventListener("click", function () {
//       const index = this.getAttribute("data-index");

//       const targetAccordion = document.getElementById("accordion" + index);

//       console.log(targetAccordion);

//       // Check if the clicked accordion is already open
//       if (targetAccordion.classList.contains("show")) {
//         targetAccordion.classList.remove("show"); // Close it if it's open
//         targetAccordion.classList.add("hide"); // Close it if it's open
//       } else {
//         // Close all other accordions
//         document
//           .querySelectorAll(".accordion-collapse")
//           .forEach((accordion) => {
//             accordion.classList.remove("show");
//           });

//         // Open the clicked accordion
//         targetAccordion.classList.add("show");
//       }
//     });
//   });
// });

//cart-slider
// document.addEventListener("DOMContentLoaded", () => {
//   let mainSlider = document.querySelector(".cartMainSlider").swiper;
//   let miniSlider = document.querySelector(".cartMiniSlider").swiper;
//   let minislides = document.querySelectorAll(".cartMiniSlider .swiper-slide");

//   mainSlider.on("slideChange", function () {
//     let realIndex = mainSlider.realIndex;

//     miniSlider.slides.forEach((slide) => slide.classList.remove("active"));

//     let activeSlide = miniSlider.slides[realIndex];
//     if (activeSlide) {
//       activeSlide.classList.add("active");
//     }
//     miniSlider.slideToLoop(realIndex, 500);
//   });

//   minislides.forEach((item, i) => {
//     item.addEventListener("click", () => {
//       mainSlider.slideToLoop(i, 500); // Use slideToLoop to account for looping
//     });
//   });
// });

// document.addEventListener("DOMContentLoaded", () => {
//   // Select the predictive search element
//   const predictiveSearch = document.querySelector(".predictive-search");
//   const resetButton = document.querySelector(
//     ".search-modal__form .reset__button"
//   );

//   // Function to toggle the class on the body based on the 'open' attribute
//   const toggleBodyClass = () => {
//     if (predictiveSearch.getAttribute("results") === "true") {
//       document.body.classList.add("predictive-search-open");
//       resetButton.classList.remove("hidden");
//     } else {
//       document.body.classList.remove("predictive-search-open");
//       resetButton.classList.add("hidden");
//     }
//   };

//   // Initial check when the page loads
//   toggleBodyClass();

//   // Listen for attribute changes on the predictive search element
//   const observer = new MutationObserver((mutations) => {
//     mutations.forEach((mutation) => {
//       if (mutation.attributeName === "results") {
//         toggleBodyClass();
//       }
//     });
//   });

//   // Observe changes to attributes on the predictive search element
//   observer.observe(predictiveSearch, { attributes: true });

//   // Example: Manually opening the predictive search for demonstration
//   // predictiveSearch.setAttribute('open', 'true');
// });

// document.addEventListener("DOMContentLoaded", () => {
//   // home reels

//   let reelCardBtns = document.querySelectorAll(".home-listing .expert-card");

//   reelCardBtns.forEach((item) => {
//     let btn = item.querySelector(".play-btn");
//     let vdo = item.querySelector("video");

//     if (btn && vdo) {
//       btn.addEventListener("click", () => {
//         console.log("butotn clciked");
//         if (vdo.paused) {
//           // Play the video if it's paused
//           btn.classList.add("playing");
//           vdo.play();

//           // Pause and reset other videos
//           reelCardBtns.forEach((card) => {
//             if (card !== item) {
//               let otherVideo = card.querySelector("video");
//               let plaYbtn = card.querySelector(".play-btn");
//               if (otherVideo) {
//                 otherVideo.pause();
//                 // otherVideo.currentTime = 0;
//               }
//               plaYbtn.classList.remove("playing");
//             }
//           });
//         } else {
//           // Pause the video if it's playing
//           btn.classList.remove("playing");
//           vdo.pause();
//         }
//       });
//     }
//   });
// });

// document.addEventListener("DOMContentLoaded", () => {
//   const shareBtn = document.querySelector(".js-share-button");

//   const updateWishlistButtonPosition = () => {
//     if (shareBtn) {
//       // Get the position of the share button relative to the document
//       const shareBtnTop = shareBtn.getBoundingClientRect().top + window.scrollY;
//       const wishlistBtnTopPosition = shareBtnTop + shareBtn.offsetHeight + 10; // 10px gap from share button

//       // Update the CSS variable with the new position value
//       document.documentElement.style.setProperty(
//         "--wishlist-btn-top",
//         `${wishlistBtnTopPosition}px`
//       );
//     }
//   };

//   // Initial position update
//   updateWishlistButtonPosition();

//   // Update position on scroll
//   window.addEventListener("scroll", updateWishlistButtonPosition);
// });

// reels detail pge

// document.addEventListener("DOMContentLoaded", () => {
//   const reelCardBtnsDetail = document.querySelectorAll(
//     ".expert-detail-page .expert-card"
//   );

//   reelCardBtnsDetail.forEach((item) => {
//     const btn = item.querySelector(".play-btn");
//     const vdo = item.querySelector("video");

//     let isVideoPlaying = false;

//     btn.addEventListener("click", (e) => {
//       if (!isVideoPlaying) {
//         btn.classList.add("playing");
//         vdo.play();

//         // Pause other videos
//         reelCardBtnsDetail.forEach((card) => {
//           if (card !== item) {
//             const otherVideo = card.querySelector("video");
//             const otherBtn = card.querySelector(".play-btn");
//             if (otherVideo && otherBtn) {
//               otherVideo.pause();
//               otherBtn.classList.remove("playing");
//             }
//           }
//         });
//       } else {
//         btn.classList.remove("playing");
//         vdo.pause();
//       }

//       vdo.addEventListener("play", () => {
//         isVideoPlaying = true;
//       });
//       vdo.addEventListener("pause", () => {
//         isVideoPlaying = false;
//       });
//     });
//   });
// });
// document.addEventListener("DOMContentLoaded", function () {
//     let url = new URL(window.location.href);
//     let currentVariant = url.searchParams.get("variant");

//     const observer = new MutationObserver(() => {
//         let newUrl = new URL(window.location.href);
//         let newVariant = newUrl.searchParams.get("variant");

//         if (newVariant && newVariant !== currentVariant) {
//             location.reload();
//         }
//     });

//     observer.observe(document.body, { childList: true, subtree: true });
// });

